// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiAnonymousClientCollectionTable/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiAnonymousClientCollectionTable/getRows', payload).then(getData);

export const getRow = (rowID) => http.get(`apiAnonymousClientCollectionTable/getRow&RowID=${rowID}`).then(getData);

export const create = (row) => http.post('apiAnonymousClientCollectionTable/addRow', row).then(getData);

export const update = (row) => http.post('apiAnonymousClientCollectionTable/editRow&RowID=' + row.ID, row).then(getData);

export const remove = (row) => http.post('apiAnonymousClientCollectionTable/deleteRow', row).then(getData);

export const getCollectionDetails = (payload) => http.post('apiAnonymousClientCollectionTable/getCollectionDetails',payload).then(getData);

export const setOptOut = (payload) => http.post('apiAnonymousClientCollectionTable/optOutOfSurvey',payload).then(getData);

export const getOptOutOptions = (payload) => http.get('apiAnonymousClientCollectionTable/getOptOutOptions').then(getData);

export const getTableActions = (payload = null) => http.post('apiAnonymousClientCollectionTable/getTableActions', payload).then(getData);